import { useTranslation } from 'react-i18next';

import { usePathTo } from '@/utils/useUrlParams';
import { Button } from '@arco-design/web-react';
import { homePath } from '../constants';
import { ErrorPage } from '../errorPage';

export function Page401() {
  const { t } = useTranslation();
  const navigate = usePathTo();
  return (
    <ErrorPage
      title="401"
      des={t('components:no.permission.or.login.expired.please.log.in.again')}
      img="/images/img_401.png"
    >
      <Button type="primary" onClick={() => navigate(homePath)}>
        点击登录
      </Button>
    </ErrorPage>
  );
}
